import type { HpChildComponentProps } from 'components/shared/componentWithModal/componentWithModal';
import { useState } from 'react';
import { PaymentInfoPage } from './paymentInfoPage';
import { PaymentPortalPage } from '../../shared/paymentPortalPage';
import { PaymentSuccessPage } from './paymentSuccessPage';
import { PageNavigation } from 'components/layout/navigation/pageNavigation';
import { PATH } from 'interfaces/pathTypes';
import { Title } from 'components/layout/header/title';

import './arrearsPayment.scss';

export const ArrearsPayment = ({ selectedPolicy }: HpChildComponentProps): JSX.Element => {
  const [clickedContinue, setClickedContinue] = useState(false);
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const renewalPaymentAmount = 105.33; // Not yet implemented in API

  return (
    <>
      <Title title="MAKE A PAYMENT" icon="credit-card-circle" id="renewal-payment" />
      <div className="payment-container">
        {clickedContinue ? (
          renewalPaymentAmount && (
            <PaymentPortalPage
              paymentSuccessPage={<PaymentSuccessPage renewalPaymentAmount={renewalPaymentAmount} />}
            />
          )
        ) : (
          <PaymentInfoPage
            selectedPolicy={selectedPolicy}
            setClickContinue={setClickedContinue}
            acceptedTerms={acceptedTerms}
            setAcceptedTerms={setAcceptedTerms}
            renewalPaymentAmount={renewalPaymentAmount}
          />
        )}
      </div>
      <PageNavigation page={PATH.ARREARS_PAYMENT} />
    </>
  );
};
